import { useMutation } from "@tanstack/react-query";
import { updatePassword } from "../services/users.service";

export const useUpdatePassword = () => {
  return useMutation({
    mutationFn: updatePassword,
  });
};
